import { render } from "./PlanillaSupervision.vue?vue&type=template&id=47517d4e&scoped=true"
import script from "./PlanillaSupervision.vue?vue&type=script&lang=js"
export * from "./PlanillaSupervision.vue?vue&type=script&lang=js"

import "./PlanillaSupervision.vue?vue&type=style&index=0&id=47517d4e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47517d4e"]])

export default __exports__